export const INDEXED_DB_TIMEOUT = 5000;
export const INDEXED_DB_RECOVERY_RETRY_BASE_DELAY_MS = 1000;
export const INDEXED_DB_RECOVERY_RETRY_MAX_DELAY_MS = 30000;
export const INDEXED_DB_RECOVERY_RETRY_MAX_ATTEMPTS = 5;
